module.exports = __webpack_public_path__ + "img/google-play-download.24d83bc4.png";